"use strict";
exports.__esModule = true;
var p2s = /,?([a-z]),?/gi;
function parsePathArray(path) {
    return path.join(',').replace(p2s, '$1');
}
exports["default"] = parsePathArray;
//# sourceMappingURL=parse-path-array.js.map